// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonCustom_root__1s_ol","green":"ButtonCustom_green__1y2W1","grey":"ButtonCustom_grey__3qhHu","red":"ButtonCustom_red__2Ukdw"};